import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';

@Injectable()
export class MarcaService extends TokenCommonService  {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  getDestacadas (params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (params) {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }

    return this.http.get(`${ environment.API_URL }marcas/destacadas?per_page=6&page=1`, params)
      .map(res => {
        return res.json().data;
      });
  }

  all (params?: any) {
    return this.tokenGet(`${ environment.API_URL }marcas`, params);
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }marcas/${id}`, data);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }marcas`, data);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/marca/marca.service.ts